/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Admission Platform API - Venues
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateVenueRequest,
  UpdateVenueRequest,
  Venue
} from './model/venues';





/**
 * @summary List all venues
 */
export type listVenuesResponse200 = {
  data: Venue[]
  status: 200
}

export type listVenuesResponseSuccess = (listVenuesResponse200) & {
  headers: Headers;
};
;

export type listVenuesResponse = (listVenuesResponseSuccess)

export const getListVenuesUrl = () => {


  

  return `/api/venues`
}

export const listVenues = async ( options?: RequestInit): Promise<listVenuesResponse> => {
  
  const res = await fetch(getListVenuesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: listVenuesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listVenuesResponse
}





export const getListVenuesQueryKey = () => {
    return [
    `/api/venues`
    ] as const;
    }

    
export const getListVenuesQueryOptions = <TData = Awaited<ReturnType<typeof listVenues>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVenues>>, TError, TData>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVenuesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVenues>>> = ({ signal }) => listVenues({ signal, ...fetchOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVenues>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVenuesQueryResult = NonNullable<Awaited<ReturnType<typeof listVenues>>>
export type ListVenuesQueryError = unknown


/**
 * @summary List all venues
 */

export function useListVenues<TData = Awaited<ReturnType<typeof listVenues>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVenues>>, TError, TData>, fetch?: RequestInit}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVenuesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary Create a new venue
 */
export type createVenueResponse201 = {
  data: Venue
  status: 201
}

export type createVenueResponseSuccess = (createVenueResponse201) & {
  headers: Headers;
};
;

export type createVenueResponse = (createVenueResponseSuccess)

export const getCreateVenueUrl = () => {


  

  return `/api/venues`
}

export const createVenue = async (createVenueRequest: CreateVenueRequest, options?: RequestInit): Promise<createVenueResponse> => {
  
  const res = await fetch(getCreateVenueUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createVenueRequest,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: createVenueResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createVenueResponse
}




export const getCreateVenueMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenue>>, TError,{data: CreateVenueRequest}, TContext>, fetch?: RequestInit}
): UseMutationOptions<Awaited<ReturnType<typeof createVenue>>, TError,{data: CreateVenueRequest}, TContext> => {

const mutationKey = ['createVenue'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVenue>>, {data: CreateVenueRequest}> = (props) => {
          const {data} = props ?? {};

          return  createVenue(data,fetchOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CreateVenueMutationResult = NonNullable<Awaited<ReturnType<typeof createVenue>>>
    export type CreateVenueMutationBody = CreateVenueRequest
    export type CreateVenueMutationError = unknown

    /**
 * @summary Create a new venue
 */
export const useCreateVenue = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenue>>, TError,{data: CreateVenueRequest}, TContext>, fetch?: RequestInit}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createVenue>>,
        TError,
        {data: CreateVenueRequest},
        TContext
      > => {
      return useMutation(getCreateVenueMutationOptions(options));
    }
    
/**
 * @summary Get venue by ID
 */
export type getVenueResponse200 = {
  data: Venue
  status: 200
}

export type getVenueResponse404 = {
  data: void
  status: 404
}

export type getVenueResponseSuccess = (getVenueResponse200) & {
  headers: Headers;
};
export type getVenueResponseError = (getVenueResponse404) & {
  headers: Headers;
};

export type getVenueResponse = (getVenueResponseSuccess | getVenueResponseError)

export const getGetVenueUrl = (id: string,) => {


  

  return `/api/venues/${id}`
}

export const getVenue = async (id: string, options?: RequestInit): Promise<getVenueResponse> => {
  
  const res = await fetch(getGetVenueUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: getVenueResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getVenueResponse
}





export const getGetVenueQueryKey = (id: string,) => {
    return [
    `/api/venues/${id}`
    ] as const;
    }

    
export const getGetVenueQueryOptions = <TData = Awaited<ReturnType<typeof getVenue>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVenue>>, TError, TData>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVenueQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenue>>> = ({ signal }) => getVenue(id, { signal, ...fetchOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVenue>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVenueQueryResult = NonNullable<Awaited<ReturnType<typeof getVenue>>>
export type GetVenueQueryError = void


/**
 * @summary Get venue by ID
 */

export function useGetVenue<TData = Awaited<ReturnType<typeof getVenue>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVenue>>, TError, TData>, fetch?: RequestInit}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVenueQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary Update venue
 */
export type updateVenueResponse200 = {
  data: Venue
  status: 200
}

export type updateVenueResponse404 = {
  data: void
  status: 404
}

export type updateVenueResponseSuccess = (updateVenueResponse200) & {
  headers: Headers;
};
export type updateVenueResponseError = (updateVenueResponse404) & {
  headers: Headers;
};

export type updateVenueResponse = (updateVenueResponseSuccess | updateVenueResponseError)

export const getUpdateVenueUrl = (id: string,) => {


  

  return `/api/venues/${id}`
}

export const updateVenue = async (id: string,
    updateVenueRequest: UpdateVenueRequest, options?: RequestInit): Promise<updateVenueResponse> => {
  
  const res = await fetch(getUpdateVenueUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateVenueRequest,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: updateVenueResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateVenueResponse
}




export const getUpdateVenueMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenue>>, TError,{id: string;data: UpdateVenueRequest}, TContext>, fetch?: RequestInit}
): UseMutationOptions<Awaited<ReturnType<typeof updateVenue>>, TError,{id: string;data: UpdateVenueRequest}, TContext> => {

const mutationKey = ['updateVenue'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVenue>>, {id: string;data: UpdateVenueRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateVenue(id,data,fetchOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVenueMutationResult = NonNullable<Awaited<ReturnType<typeof updateVenue>>>
    export type UpdateVenueMutationBody = UpdateVenueRequest
    export type UpdateVenueMutationError = void

    /**
 * @summary Update venue
 */
export const useUpdateVenue = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenue>>, TError,{id: string;data: UpdateVenueRequest}, TContext>, fetch?: RequestInit}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateVenue>>,
        TError,
        {id: string;data: UpdateVenueRequest},
        TContext
      > => {
      return useMutation(getUpdateVenueMutationOptions(options));
    }
    
/**
 * @summary Delete venue
 */
export type deleteVenueResponse204 = {
  data: void
  status: 204
}

export type deleteVenueResponse404 = {
  data: void
  status: 404
}

export type deleteVenueResponseSuccess = (deleteVenueResponse204) & {
  headers: Headers;
};
export type deleteVenueResponseError = (deleteVenueResponse404) & {
  headers: Headers;
};

export type deleteVenueResponse = (deleteVenueResponseSuccess | deleteVenueResponseError)

export const getDeleteVenueUrl = (id: string,) => {


  

  return `/api/venues/${id}`
}

export const deleteVenue = async (id: string, options?: RequestInit): Promise<deleteVenueResponse> => {
  
  const res = await fetch(getDeleteVenueUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: deleteVenueResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteVenueResponse
}




export const getDeleteVenueMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVenue>>, TError,{id: string}, TContext>, fetch?: RequestInit}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVenue>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteVenue'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVenue>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteVenue(id,fetchOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVenueMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVenue>>>
    
    export type DeleteVenueMutationError = void

    /**
 * @summary Delete venue
 */
export const useDeleteVenue = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVenue>>, TError,{id: string}, TContext>, fetch?: RequestInit}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteVenue>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteVenueMutationOptions(options));
    }
    
